import Table from '../../atoms/table/table';

export const CommissionsTableHeader = () => {
  return (
    <Table.Row>
      <Table.HeaderCell>Commessa</Table.HeaderCell>
      <Table.HeaderCell>Globale</Table.HeaderCell>
      <Table.HeaderCell>Ruoli di riferimento</Table.HeaderCell>
      <Table.HeaderCell>Utenti di riferimento</Table.HeaderCell>
      <Table.HeaderCell></Table.HeaderCell>
    </Table.Row>
  );
};
